// We need to import the connectHighlight to our import
import React from "react";
import { connectHighlight } from "react-instantsearch-dom";

const Highlight = connectHighlight(
  ({ highlight, attribute, hit, highlightProperty }) => {
    const parsedHit = highlight({
      attribute,
      hit,
      highlightProperty: "_highlightResult"
    });
    const highlightedHit = parsedHit.map((part, idx) => {
      if (part.isHighlighted) {
        return (
          <span key={idx} style={{ backgroundColor: "#ffff99" }}>
            {part.value}
          </span>
        );
      }
      return part.value;
    });
    return <span>{highlightedHit}</span>;
  }
);

export default Highlight;
